import React, {forwardRef, useEffect, InputHTMLAttributes, Ref} from "react"
import classNames from "classnames"

interface Props extends InputHTMLAttributes<HTMLInputElement> {
	checked?: boolean
	isValid?: boolean
	disabled?: boolean
	light?: boolean
	indeterminate?: boolean
}

export default forwardRef(function Checkbox(
	{checked, onChange, isValid = true, light, indeterminate, ...inputProps}: Props,
	ref: Ref<HTMLInputElement>
) {
	useEffect(() => {
		const input = (ref as React.RefObject<HTMLInputElement>)?.current
		if (input) {
			input.indeterminate = Boolean(indeterminate && !checked)
		}
	}, [ref, indeterminate, checked])

	const className = classNames("checkbox", !isValid && "invalid", light && "light", indeterminate && "indeterminate")

	return (
		<input
			className={className}
			type="checkbox"
			ref={ref}
			checked={checked}
			onChange={onChange}
			aria-checked={indeterminate ? "mixed" : checked}
			{...inputProps}
		/>
	)
})
